<template>
  <div class="comp-wrapper">
    <List />
    <FooterBar />
  </div>
</template>

<script>
import List from "./List";
import FooterBar from "../../components/FloatingFooter/FooterBar.vue";

export default {
  name: "ListView",
  components: {
    List,
    FooterBar,
  },
};
</script>